import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-gb-eng",
  "use": "icon-icon-gb-eng-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-gb-eng\">\n  <path fill=\"#fff\" d=\"M0 0h512v512H0z\" />\n  <path fill=\"#ce1124\" d=\"M215 0h82v512h-82z\" />\n  <path fill=\"#ce1124\" d=\"M0 215h512v82H0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol